/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Hide_PasswordInputs */

const en_common_hide_password = /** @type {(inputs: Common_Hide_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hide password`)
};

const es_common_hide_password = /** @type {(inputs: Common_Hide_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ocultar contraseña`)
};

/**
* | output |
* | --- |
* | "Hide password" |
*
* @param {Common_Hide_PasswordInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const common_hide_password = /** @type {((inputs?: Common_Hide_PasswordInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Hide_PasswordInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_common_hide_password(inputs)
	return en_common_hide_password(inputs)
});